export const filterList = [
  {
    id: 1,
    value: "day"
  },
  {
    id: 2,
    value: "week"
  },
  {
    id: 3,
    value: "month"
  },
  {
    id: 4,
    value: "flex"
  }
];
